import React from 'react';
import { MapPin } from 'lucide-react';
export function HomeFacilitySection() {
  return <section id="facility" className="py-24 bg-white" data-id="element-1033">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1034">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1035">
          <div data-id="element-1036">
            <div className="inline-flex items-center gap-2 text-[#FF6B35] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-1037">
              <MapPin className="w-4 h-4" data-id="element-1038" />
              Bloomington, IL
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-black mb-6" data-id="element-1039">
              Train in Our New <br data-id="element-1040" />
              <span className="text-[#00D4FF]" data-id="element-1041">4,200 sq. ft Facility</span>
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1042">
              <p data-id="element-1043">
                Walker's Martial Arts is proud to announce the opening of our
                brand-new 4,200 square foot training facility in Bloomington.
              </p>
              <p data-id="element-1044">
                Designed with students and families in mind, our expanded space
                features:
              </p>
              <ul className="space-y-3 ml-4" data-id="element-1045">
                <li className="flex items-start gap-3" data-id="element-1046">
                  <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-1047" />
                  <span data-id="element-1048">Spacious, state-of-the-art training floors</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1049">
                  <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-1050" />
                  <span data-id="element-1051">
                    Modern equipment to support all programs and age groups
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1052">
                  <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-1053" />
                  <span data-id="element-1054">
                    A welcoming, family-friendly environment that fosters
                    confidence, discipline, and community
                  </span>
                </li>
              </ul>
              <p data-id="element-1055">
                Since 1999, Walker's Martial Arts has proudly served McLean
                County. Now, in our largest facility to date, we look forward to
                continuing our mission—helping families train together, grow
                together, and succeed together.
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-1056">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl" data-id="element-1057">
              <img src="https://cdn.magicpatterns.com/uploads/tsfAcNz1CUYiL1PqFKD8mu/website2Bnew2Blocation.webp" alt="Walker's Martial Arts Training Facility" className="w-full h-full object-cover" data-id="element-1058" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#00D4FF] -z-10 rounded-xl" data-id="element-1059" />
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#FF6B35]/20 -z-10 rounded-full" data-id="element-1060" />
          </div>
        </div>
      </div>
    </section>;
}